import type { GeneratedIntakeField, IntakeFieldValue } from './types';

const SERVICE_MODALITY_FIELD_KEY = 'service_modality';
const COVERAGE_TYPE_FIELD_KEY = 'coverage_type';

const COVERAGE_TYPE_LABELS: Readonly<Record<string, string>> = {
  claims_made: 'Claims made',
  occurrence: 'Occurrence',
};

const SERVICE_MODALITY_LABELS: Readonly<Record<string, string>> = {
  in_person_only: 'In person only',
  telehealth_and_in_person: 'Telehealth and in person',
  telehealth_only: 'Telehealth only',
};

function isServiceModalityField(field: GeneratedIntakeField): boolean {
  return (
    field.field_key === SERVICE_MODALITY_FIELD_KEY ||
    field.destination.field_key === SERVICE_MODALITY_FIELD_KEY
  );
}

function isCoverageTypeField(field: GeneratedIntakeField): boolean {
  return (
    field.field_key === COVERAGE_TYPE_FIELD_KEY ||
    field.destination.field_key === COVERAGE_TYPE_FIELD_KEY
  );
}

function readableLegacyValue(value: string): string {
  const words = value.replace(/_+/g, ' ').trim();
  return words ? `${words.charAt(0).toUpperCase()}${words.slice(1)}` : value;
}

function displayStringValue(field: GeneratedIntakeField, value: string): string {
  if (isServiceModalityField(field)) {
    return SERVICE_MODALITY_LABELS[value] ?? readableLegacyValue(value);
  }
  if (isCoverageTypeField(field)) {
    return COVERAGE_TYPE_LABELS[value] ?? readableLegacyValue(value);
  }
  return value;
}

export function displayIntakeFieldValue(
  field: GeneratedIntakeField,
  value: IntakeFieldValue,
): string {
  if (Array.isArray(value)) return value.map(entry => displayStringValue(field, entry)).join(', ');
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'string') return displayStringValue(field, value);
  return String(value);
}
